'use client';

import type { Route } from 'next';
import type { Session } from 'next-auth';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import styles from './CommonFooter.module.scss';

export type FooterMenuItem = {
  href?: string;
  to?: string;
  text: string;
};

export type CommonFooterProps = {
  siteName: string;
  copyright: string;
  menuListLeft: Array<FooterMenuItem>;
  menuListRight: Array<FooterMenuItem>;
};

function CommonFooter({ siteName, copyright, menuListLeft, menuListRight }: CommonFooterProps) {
  const pathname = usePathname();
  const isCollaboPage = pathname?.includes('collabo');

  return (
    <footer className={styles.componentStyle}>
      <div className={styles.container}>
        {!isCollaboPage && (
          <div className={styles.footerTitle}>
            <img src='/logo-white.png' alt={siteName} />
          </div>
        )}
        <div className={styles.menuListWrapper}>
          <ul className={styles.menuList}>{menuList(menuListLeft)}</ul>
          <ul className={styles.menuList}>{menuList(menuListRight)}</ul>
        </div>
        <p className={styles.copyright}>{copyright}</p>
      </div>
    </footer>
  );
}

function menuList(list: Array<FooterMenuItem>) {
  const result: Array<React.ReactNode> = [];

  const getTestId = (text: string) => {
    switch (text) {
      case '利用規約':
        return 'terms-link';
      case '特定商取引法に基づく表記':
        return 'transaction-law-link';
      case '資金決済法に基づく表記':
        return 'funds-settlement-law-link';
      case '景品のお取り扱いについての注意事項':
        return 'prize-handling-link';
      default:
        return undefined;
    }
  };

  list.forEach((item, index) => {
    const testId = getTestId(item.text);
    result.push(
      <li
        key={`menu_${
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          index
        }`}
      >
        {item.href ? (
          <a href={item.href} data-testid={testId}>
            {item.text}
          </a>
        ) : (
          <Link href={item.to as Route} prefetch={false} data-testid={testId}>
            {item.text}
          </Link>
        )}
      </li>,
    );
  });

  return result;
}

export default CommonFooter;
